/**
 * Shared visible fallback for content detail screens whose lookup failed —
 * shown instead of a silent blank page.
 */
import * as React from 'react';
import { Container } from 'reactstrap';
import { useTrans } from '../../Store/System/LocalizationStore';

export const ContentNotFound: React.FC = () => {
  const { t } = useTrans();

  return (
    <Container style={{ padding: '48px', textAlign: 'center' }}>
      {t('contentView.notFound', { defaultValue: 'Content could not be loaded.' })}
    </Container>
  );
};
